// @ts-nocheck
const hostName = window.location.hostname;

let BASE_URL = '';
let isProduction = false;
let BEARER_TOKEN = "";

if (hostName === "localhost") {
  BASE_URL = "http://localhost:7071/apis/";
  BEARER_TOKEN =
    "ceZP6Tocqc84TBmiFsgdpG4O0cSlvyRcG8zWFD4s0pfgeTpAlvtlgLRAGU2kqCYE";
  isProduction = false;
} else if (hostName.includes('stgn') || hostName.includes('staging')) {
  BASE_URL = "https://copilot-stgn-api.avsight.net/apis/";
  BEARER_TOKEN =
    "ceZP6Tocqc84TBmiFsgdpG4O0cSlvyRcG8zWFD4s0pfgeTpAlvtlgLRAGU2kqCYE";
  isProduction = false;
} else if (hostName.includes('dev') || hostName.includes('azurestaticapps')) {
  // DEV tier — av-copilot-dev resource group (Function App av-copilot-dev-fapp,
  // Static Web App av-copilot-dev-ui, copilotsb Salesforce sandbox). Matches the custom
  // domain copilot-dev.avsight.net and the SWA default *.azurestaticapps.net host.
  // MUST stay ahead of the prod fallthrough so the dev host never resolves to the prod API.
  BASE_URL = "https://av-copilot-dev-fapp.azurewebsites.net/apis/";
  BEARER_TOKEN =
    "ceZP6Tocqc84TBmiFsgdpG4O0cSlvyRcG8zWFD4s0pfgeTpAlvtlgLRAGU2kqCYE";
  isProduction = false;
} else {
  BASE_URL = "https://copilot-prod-api.avsight.net/apis/";
  BEARER_TOKEN = "1bb82e0f-0809-4b92-9f22-c0d826798107";
  isProduction = true;
}

const environment = {
  production: isProduction,
  BASE_URL: BASE_URL,
  BEARER_TOKEN: BEARER_TOKEN,
  releases: [
    {
      name: "Denali 1",
      article_url: "https://inscaletech.my.site.com/support/s/article/d1",
    },
    {
      name: "Denali 2",
      article_url: "https://inscaletech.my.site.com/support/s/article/d2",
    },
    {
      name: "Denali 3",
      article_url: "https://inscaletech.my.site.com/support/s/article/d3",
    },
  ],
};

export default environment;
